import styles from './styles.module.scss'
import clsx from 'clsx'
import { intl } from 'src/i18n'

export const ExchangeHeaderFees = ({ data }) => {
  const { fees, deposit, coreType } = data

  return (
    <div className={styles.exchangeHeaderFees}>
      {coreType === 'Centralized' && (
        <>
          {fees && fees.length > 1 ? (
            fees.map(i => (
              <div className={styles.infoColumn} key={i}>
                <div className={styles.feesLabel}>
                  {i.substring(0, 5)}
                  {intl.t('exchangeDetails.components.exchangeHeaderFees.fee')}
                </div>
                <div className={styles.feesValue}>{i.substring(6)}</div>
              </div>
            ))
          ) : (
            <>
              <div className={styles.infoColumn}>
                <div className={styles.feesLabel}>
                  {intl.t(
                    'exchangeDetails.components.exchangeHeaderFees.maker'
                  )}
                </div>
                <div className={styles.feesValue}>-</div>
              </div>
              <div className={styles.infoColumn}>
                <div className={styles.feesLabel}>
                  {intl.t(
                    'exchangeDetails.components.exchangeHeaderFees.taker'
                  )}
                </div>
                <div className={styles.feesValue}>-</div>
              </div>
            </>
          )}
          <div className={clsx(styles.infoColumn, styles.last)}>
            {deposit ? (
              <>
                <div className={styles.feesLabel}>
                  {intl.t(
                    'exchangeDetails.components.exchangeHeaderFees.deposit'
                  )}
                </div>
                <div className={styles.feesValue}>
                  {deposit.replace('N/A', '-') || '-'}
                </div>
              </>
            ) : (
              <>
                <div className={styles.feesLabel}>
                  {intl.t(
                    'exchangeDetails.components.exchangeHeaderFees.deposit'
                  )}
                </div>
                <div className={styles.feesValue}>-</div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default ExchangeHeaderFees
